import { useState } from "react";
import Link from "next/link";
import { Form, Col, Button, InputGroup } from "react-bootstrap";
import { signIn } from "next-auth/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useRouter } from "next/router";
import styles from "@/styles/CredentialSignInCard.module.css";
import { customerServices } from "@/services/customerServices";
import { toast } from "react-toastify";
import { useSession } from "next-auth/react";
import { getSession } from "next-auth/react";
import { useDispatch } from "react-redux";
import { setSession } from "@/redux/features/userSlice";
import { setUserData } from "@/redux/features/userSlice";

function CredentialSignInCard(props) {
  const { data: session } = useSession();
  // const session = data?.user;
  const { pageStateHandler, userType } = props;
  const dispatch = useDispatch();
  const [password, setPassword] = useState({
    type: "password",
    icon: "fa-eye-slash",
  });
  const [signInError, setSignInError] = useState(null);
  const router = useRouter();
  const appointmentBooking =
    JSON.parse(sessionStorage.getItem("appointmentBooking")) ?? {};
  const courseBooking =
    JSON.parse(sessionStorage.getItem("courseBooking")) ?? {};

  const fetchProfile = async (user) => {
    const res = await customerServices.getProfile(user);
    if (res.status) {
      router.push(`/courses/${courseBooking?.detailData?.course?.slug}/detail`);
      const data = res.data;
      dispatch(setSession(user));
      dispatch(setUserData(data));
      // setProfile({ ...data, mobile_number: data?.mobile_number ?? "" });
    } else {
      toast.error(res.message, { autoClose: 5000 });
    }
  };

  const handleClickShowPassword = () => {
    password.type === "password"
      ? setPassword({ ...password, type: "text", icon: "fa-eye" })
      : setPassword({ ...password, type: "password", icon: "fa-eye-slash" });
  };

  // Yup schema to validate the form
  const validationSchema = Yup.object().shape({
    email: Yup.string().required().email(),
    password: Yup.string().required().min(4),
  });

  // Formik hook to handle the form state
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    // Pass the Yup schema to validate the form
    validationSchema,
    // Handle form submission
    onSubmit: async ({ email, password }) => {
      const res = await signIn("credentials", {
        email,
        password,
        role: userType,
        redirect: false,
      });

      if (res?.error && !res?.ok) {
        if (res.error == "CredentialsSignin") {
          setSignInError("Something went wrong, please try again later!");
        } else {
          setSignInError(res.error);
        }
      } else {
        setTimeout(async () => {
          const updatedSession = await getSession();
          if (userType == "customer") {
            if (
              (typeof window !== "undefined" &&
                appointmentBooking &&
                Object.keys(appointmentBooking).length) ||
              (typeof window !== "undefined" &&
                courseBooking &&
                Object.keys(courseBooking).length)
            ) {
              if (
                appointmentBooking &&
                Object.keys(appointmentBooking).length
              ) {
                if (
                  appointmentBooking?.selectedAppointment &&
                  appointmentBooking?.selectedAppointment?.is_free == 1
                ) {
                  router.push({
                    pathname: "/free-thank-you",
                    query: {
                      type: "appointment",
                      id: appointmentBooking.bookedSlotId,
                      healer_tz: appointmentBooking.healer_tz,
                    },
                  });
                  return;
                } else {
                  router.push({
                    pathname: "/payment",
                    query: {
                      type: "appointment",
                      id: appointmentBooking.bookedSlotId,
                    },
                  });
                  return;
                }
              }
              if (
                courseBooking &&
                Object.keys(courseBooking).length &&
                updatedSession
              ) {
                if (
                  courseBooking?.detailData &&
                  courseBooking?.detailData?.course &&
                  courseBooking?.detailData?.course?.is_free == 1 &&
                  updatedSession?.user?.id
                ) {
                  const res =
                    await customerServices.customerCheckClassAvailable({
                      class_id:
                        courseBooking?.detailData?.course?.classes[0]?.id,
                      session_id: courseBooking?.detailData?.session_id,
                      customer_id: updatedSession?.user?.id,
                    });

                  if (res.status) {
                    sessionStorage.setItem(
                      "courseBooking",
                      JSON.stringify({
                        detailData: courseBooking?.detailData,
                        bookedSlotId: res.data.id,
                      })
                    );

                    router.push({
                      pathname: "/free-thank-you",
                      query: {
                        type: "course",
                        id: courseBooking.bookedSlotId,
                        healer_tz:
                          courseBooking?.detailData?.course?.healer?.time_zone,
                      },
                    });
                    return;
                  } else {
                    fetchProfile(updatedSession?.user);
                    toast.warning(res.message, {
                      autoClose: 5000,
                    });
                  }
                } else {
                  router.push({
                    pathname: "/payment",
                    query: { type: "course", id: courseBooking.bookedSlotId },
                  });
                  return;
                }
              }
            } else {
              router.push({
                pathname: "/customer/profile",
                query: { credential: true },
              });
            }
          } else {
            router.push({
              pathname: "/healer/my-account",
              query: { credential: true },
            });
          }
        }, 1000);
      }
    },
  });

  const { errors, touched, values, handleChange, handleSubmit } = formik;

  return (
    <Col sm={7} className="align-self-center">
      <div className={styles["login-customer-card"]}>
        <div className={styles["card-header"]}>
          <h4 className={styles["card-heading"]}>
            {userType == "customer" ? "Customer Log In" : "Healer Log In"}
          </h4>
          <p>Log In with your email address</p>
        </div>
        <div className={styles["form-customer"]}>
          <Form onSubmit={handleSubmit}>
            <InputGroup className={styles["input-group"] + " mb-3"}>
              <InputGroup.Text className={styles["input-group-text"]}>
                <i className="ri-mail-line"></i>
              </InputGroup.Text>
              <Form.Control
                id="email"
                name="email"
                className={styles["form-control"]}
                type="email"
                onChange={handleChange}
                value={values.email}
                placeholder="Email"
              />
              <span className="w-100">
                {touched.email && errors.email ? (
                  <div className="text-danger h6">{errors.email}</div>
                ) : null}
              </span>
            </InputGroup>

            <InputGroup className={styles["input-group"] + " mb-3"}>
              <InputGroup.Text className={styles["input-group-text"]}>
                <i className="ri-lock-line"></i>
              </InputGroup.Text>
              <Form.Control
                id="password"
                name="password"
                className={styles["form-control"]}
                type={password.type}
                onChange={handleChange}
                value={values.password}
                placeholder="Password"
              />
              <InputGroup.Text
                className={
                  styles["input-group-text"] + " " + styles["visible-icon"]
                }
                onClick={handleClickShowPassword}
              >
                <i className={`fa-solid ${password.icon}`}></i>
              </InputGroup.Text>
              <span className="w-100">
                {touched.password && errors.password ? (
                  <div className="text-danger h6">{errors.password}</div>
                ) : null}
              </span>
            </InputGroup>
            {signInError ? (
              <div className="text-danger">{signInError}</div>
            ) : (
              ""
            )}
            <div className={styles["form-bottom"]}>
              <div className={styles["forget-btn"]}>
                <Link
                  href={`/auth/${userType}/forgot-password`}
                  shallow={true}
                  onClick={() => pageStateHandler("forgotPassword")}
                >
                  Forgot Password<i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className={styles["backbtn"]}>
                <Link
                  href={`/auth/${userType}/social/signin`}
                  shallow={true}
                  onClick={() => pageStateHandler("socialSignIn")}
                >
                  Back <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
            <Button
              type="submit"
              className={styles["theme-btn"] + " px-5"}
              value="Sign-In"
            >
              Continue
            </Button>
          </Form>
        </div>
        <div className={styles["card-footer"]}>
          <p>
            Don&apos;t have any account?{" "}
            <Link
              href={`/auth/${userType}/social/signup`}
              shallow={true}
              onClick={() => pageStateHandler("signUp")}
            >
              Sign-Up
            </Link>
          </p>
        </div>
      </div>
    </Col>
  );
}

export default CredentialSignInCard;
